import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { injectIntl } from 'react-intl';
import UMOToolbar from './UMOToolbar';
import { SearchParams } from '../../utils/searchUtils';
import Pagination from '../Pagination';
import UMOFilter from './UMOFilter';
import { connect } from 'react-redux';
import { toggleFilterMenu } from '../../actions/umoGallery';

const mapStateToProps = (state) => ({
  isFilterExpanded: state.umoGallery.get('isFilterExpanded'),
});

const mapDispatchToProps = (dispatch) => ({
  toggleFilterView: (isFilterExpanded) =>
    dispatch(toggleFilterMenu(isFilterExpanded)),
});

function UMOGalleryHeader({
  mainTitle,
  isUMOGalleryWorkspace,
  sortBy,
  sortByIsDescending,
  dispatch,
  umoGalleryViewType,
  searchParams,
  selectedWorkspaceData,
  selectedUMOIDs,
  isSelectAll,
  copyUMOs,
  umoList,
  isSortMode,
  pageNumber,
  pageTotal,
  onPageChange,
  toggleCompareView,
  filterByList,
  metatags,
  userCollection,
  intl,
  isFilterExpanded,
  toggleFilterView,
  changeDataLanguage,
  languageList,
  selectedLanguage,
  umoTotal,
  isMetaAttachView,
}) {
  return (
    <div className="umo-gallery-header">
      <div className="umo-gallery-header__lightbox">
        {mainTitle && (
          <h3 className="umo-gallery-header__lightbox-name">{mainTitle}</h3>
        )}
      </div>
      <Pagination
        pageNumber={pageNumber}
        pageTotal={pageTotal}
        onPageChange={onPageChange}
      />
      {!isSortMode ? (
        <UMOToolbar
          dispatch={dispatch}
          sortBy={sortBy}
          sortByIsDescending={sortByIsDescending}
          umoGalleryViewType={umoGalleryViewType}
          searchParams={searchParams}
          selectedWorkspaceData={selectedWorkspaceData}
          selectedUMOIDs={selectedUMOIDs}
          isSelectAll={isSelectAll}
          isUMOGalleryWorkspace={isUMOGalleryWorkspace}
          copyUMOs={copyUMOs}
          umoList={umoList}
          isSortMode={isSortMode}
          toggleCompareView={toggleCompareView}
          isFilterExpanded={isFilterExpanded}
          onFilterToggle={toggleFilterView}
          filterByList={filterByList}
          changeDataLanguage={changeDataLanguage}
          languageList={languageList}
          selectedLanguage={selectedLanguage}
          umoTotal={umoTotal}
          isMetaAttachView={isMetaAttachView}
        />
      ) : null}
      <UMOFilter
        isFilterExpanded={isFilterExpanded}
        onFilterToggle={toggleFilterView}
        userCollection={userCollection}
        metatags={metatags}
        filterByList={filterByList}
        dispatch={dispatch}
      />
    </div>
  );
}

UMOGalleryHeader.propTypes = {
  mainTitle: PropTypes.string,
  isUMOGalleryWorkspace: PropTypes.bool,
  sortBy: PropTypes.string,
  sortByIsDescending: PropTypes.bool,
  dispatch: PropTypes.func,
  metatags: PropTypes.instanceOf(Map),
  filterByList: PropTypes.instanceOf(Array),
  userCollection: PropTypes.string,
  umoGalleryViewType: PropTypes.string,
  searchParams: PropTypes.instanceOf(SearchParams),
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  selectedUMOIDs: PropTypes.instanceOf(List),
  isSelectAll: PropTypes.bool,
  copyUMOs: PropTypes.func,
  umoList: PropTypes.instanceOf(List),
  isSortMode: PropTypes.bool,
  pageNumber: PropTypes.number,
  pageTotal: PropTypes.number,
  onPageChange: PropTypes.func,
  toggleCompareView: PropTypes.func,
  changeDataLanguage: PropTypes.func,
  selectedLanguage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  languageList: PropTypes.instanceOf(Array),
  umoTotal: PropTypes.number,
  isMetaAttachView: PropTypes.bool,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(UMOGalleryHeader));
